import React, { MouseEventHandler } from 'react'

export function crunchSrcSet(srcset: string[]) {
  return srcset.map(([url, size]) => `${url} ${size}`).join(', ')
}

export function makeArrow({
  alt,
  direction,
}: {
  alt?: string
  direction: string
}) {
  const result = ({
    className,
    onClick,
  }: {
    className: string
    onClick: MouseEventHandler<HTMLButtonElement>
  }) => {
    const disabling = className.includes('slick-disabled')
      ? ' c-pagination__item--disabled'
      : ''

    return (
      <li
        className={`c-pagination__item c-pagination__item--${direction}${disabling}`}
      >
        <button
          className={`c-pagination__link c-pagination__link--${direction}`}
          onClick={onClick}
        >
          <svg
            aria-label={alt}
            className='c-pagination__icon'
            height='18'
            role='img'
            width='18'
          >
            <use xlinkHref='#arrow'></use>
          </svg>
        </button>
      </li>
    )
  }

  return result as React.FC
}

export const MAX_REGULAR_THUMBS = 3
